// Keep calendar grouping and display independent of the browser timezone.
const moment = require('moment-timezone')
moment.tz.setDefault('Asia/Hong_Kong')
